import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { VirtualPack } from '~/Api/Analytics/VirtualBrand';
import { PRODUCT_LIST_TYPE, UserProductGroup } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashSuccessMessage } from '~/FlashMessage';
import flashMessageStyles from '~/FlashMessage/styles.less';
import { addGroupActualPacks, State as VirtualBrandState } from '~/MedicinalBrandsAnalytics/VirtualBrand';
import { buildGroupInitialUrl, CreateModal } from '~/ProductGroup';
import { Store, ThunkDispatch } from '~/Store';
import { Link } from '~/UI/Button';

interface State {
	medicinalBrandsAnalyticsVirtualBrand: VirtualBrandState;
}

interface OwnProps {
	brandName: string;
	virtualPack: VirtualPack;
	onClose(): void;
}

function mapStateToProps(
	{ medicinalBrandsAnalyticsVirtualBrand }: State,
	{ brandName, virtualPack }: OwnProps
): {
	folderSelection: boolean;
	groupType: typeof PRODUCT_LIST_TYPE;
	initialInputValue: string;
	isFetching: boolean;
} {
	return {
		folderSelection: true,
		groupType: PRODUCT_LIST_TYPE,
		initialInputValue: `${brandName} ${virtualPack.distinctName}`,
		isFetching: medicinalBrandsAnalyticsVirtualBrand.groupAddRequest !== null,
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	{ virtualPack, onClose }: OwnProps
): {
	onSave: (group: UserProductGroup) => Promise<void>;
} {
	return {
		onSave: async (group: UserProductGroup, options?: { preventGroupAdditions?: boolean }) => {
			try {
				// NOTE: useful when creating a group from a virtual pack
				if (!options?.preventGroupAdditions) {
					await dispatch(addGroupActualPacks(group, virtualPack.actualPacks));
				}
				dispatch(flashAddMessage(group));
			} catch (error) {
				dispatch(handleError(error));
			}
			onClose();
		},
	};
}

function flashAddMessage(group: UserProductGroup) {
	return (dispatch: ThunkDispatch<AnyAction>, getState: Store['getState']) => {
		const state = getState();

		dispatch(
			flashSuccessMessage(
				<Fragment>
					{'Actual packs were added to '}
					<Link styles={flashMessageStyles} title={group.name} to={buildGroupInitialUrl(group, state)}>
						{group.name}
					</Link>
				</Fragment>
			)
		);
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateModal);
